import React from 'react';
import { useAuthorization } from 'framework/authorization';
import { LinkButton } from 'framework/ui/ui-builder';
import AddIcon from '@mui/icons-material/AddOutlined';

interface CreateButtonProps {
  url: string | ((id?: Nullable<StringOrNumber>) => string);
  permissionToCheck: string | string[];
}

const UploadJournalEntryButton = ({ url, permissionToCheck, ...props }: CreateButtonProps) => {
  const { isGranted } = useAuthorization();

  return isGranted(permissionToCheck) ? (
    <LinkButton
      {...props}
      url={url}
      className="button create-btn"
      color="primary"
      onClick={(e: any) => {
        e.stopPropagation();
      }}
      variant="outlined"
      startIcon={<AddIcon />}
    >
      Upload journal entries
    </LinkButton>
  ) : null;
};

export default UploadJournalEntryButton;
